import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "10",
  cy: "5.25241",
  r: "4",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.5 15.1476C2.5 12.9384 4.29086 11.1476 6.5 11.1476H13.5C15.7091 11.1476 17.5 12.9384 17.5 15.1476V17.1476C17.5 18.0312 16.7837 18.7476 15.9 18.7476H4.1C3.21634 18.7476 2.5 18.0312 2.5 17.1476V15.1476Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }